import React from 'react';
export interface AddVictimProps {
  width?: string;
  height?: string;
  color?: string;
}
const AddVictim: React.FC<AddVictimProps> = (props): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
    >
      <g id="add-victime" transform="translate(-632 -422)">
        <circle
          id="Ellipse_9"
          data-name="Ellipse 9"
          cx="25"
          cy="25"
          r="25"
          transform="translate(632 422)"
          fill="#f0f0f0"
        />
        <g id="Victim_" data-name="Victim+" transform="translate(-3 -3)">
          <path
            id="Union_4"
            data-name="Union 4"
            d="M15.34,24H0v-.612c0-4.929,2.737-9.119,6.512-10.566a6.825,6.825,0,0,1-2.5-9.972l.694.5-.694-.5a6.549,6.549,0,0,1,10.81,0h0a6.825,6.825,0,0,1-2.507,9.974,9.947,9.947,0,0,1,5.272,5.045l.006.013a12.688,12.688,0,0,1,1.238,5.5v.58l-.605.034c-.065,0-.131.007-.2.007Zm.852-1.223h1.42a11.353,11.353,0,0,0-1.1-4.363L16.5,18.4a9.227,9.227,0,0,0-3.048-3.607l.947,2.763h1.025v1.223h-.605Zm-6.177,0H14.92l-.73-2.131-.789-2.3,0-.009-.929-2.711Zm-8.8,0h4.12c-.028-.03-.055-.062-.082-.093h0l-.011-.013-.007-.009,0,0-.01-.012h0a3.014,3.014,0,0,1-.64-1.338v0l0-.014v0l0-.014v0c0-.014-.005-.028-.007-.043v-.007l0-.01V21.2l0-.008,0-.011s0-.006,0-.008l0-.011v-.007c0-.005,0-.01,0-.016v0c0-.013,0-.026,0-.039a.021.021,0,0,0,0,0l0-.016s0,0,0,0l0-.017a0,0,0,0,0,0,0c0-.034-.006-.068-.008-.1h0v-.021c0-.027,0-.054,0-.081v0c0-.006,0-.012,0-.018v0c0-.005,0-.011,0-.017v0c0-.005,0-.011,0-.016v-.024h0a3.5,3.5,0,0,1,3.708-3.236h2.3l1.235-3.6a6.886,6.886,0,0,0-2.363-.422C5.056,13.506,1.48,17.612,1.216,22.777ZM5.73,20.765a2.3,2.3,0,0,0,2.508,2.011h.5l1.38-4.023H8.238A2.3,2.3,0,0,0,5.73,20.765ZM3.99,6.753a5.484,5.484,0,0,0,5.424,5.529,5.484,5.484,0,0,0,5.425-5.529A5.647,5.647,0,0,0,14.7,5.495H4.131A5.629,5.629,0,0,0,3.99,6.753ZM6.363,4.883H14.52a5.555,5.555,0,0,0-.68-1.325h0q-.106-.152-.221-.3ZM4.376,4.7l5.635-1.26L5.717,2.71a5.49,5.49,0,0,0-.728.848h0A5.573,5.573,0,0,0,4.376,4.7ZM6.345,2.2l5.24.892,1.559-.349a5.334,5.334,0,0,0-6.8-.544Z"
            transform="translate(648 439)"
            fill="#32335f"
          />
          <g id="Add" transform="translate(666 439)">
            <path
              id="Icon_material-add-circle-outline"
              data-name="Icon material-add-circle-outline"
              d="M10.7,6.5H9.3V9.3H6.5v1.4H9.3v2.8h1.4V10.7h2.8V9.3H10.7ZM10,3a7,7,0,1,0,7,7A7,7,0,0,0,10,3Zm0,12.6A5.6,5.6,0,1,1,15.6,10,5.607,5.607,0,0,1,10,15.6Z"
              transform="translate(-3 -3)"
              fill="#0072c6"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export default AddVictim;
